import React, { useContext, useState } from 'react';
import { CargoTemperatureLogDate } from '../types/ViewModel/CargoTempLog/CargoTemperatureLogDate';
import { ContextProps } from '../types/ContextProps';
import { CargoTemperatureLogEntry } from '../types/ViewModel/CargoTempLog/CargoTemperatureLog';
import { CargoTemperatureConfig } from '../types/ViewModel/CargoTempLog/CargoTemperatureConfig';
import { CargoTemperatureInputField } from '../types/ViewModel/CargoTempLog/CargoTemperatureInputField';
import { tabEnum } from '../components/cargo-temp-log/CargoTemperatureLogUtils';

type CargoTempLogContextType = {
    cargoTempLogDates: CargoTemperatureLogDate[];
    cargoTemperatureConfigs: CargoTemperatureConfig[] | null;
    cargoTemperatureInputFields: CargoTemperatureInputField[];
    selectedCargoTempDate: Date | null;
    isCommentsVisible: boolean;
    hasMissingConfigs: boolean;
    filteredCargoTemperatureConfigs: CargoTemperatureConfig[];
    cargoTempLogReportLog: CargoTemperatureLogEntry[];
    selectedTab: tabEnum;
    setCargoTempLogDates: (cargoTemperatureLogDates: CargoTemperatureLogDate[] | null) => void;
    setCargoTemperatureConfigs: (cargoTemperatureConfigs: CargoTemperatureConfig[] | null) => void;
    setCargoTemperatureInputFields: (cargoTemperatureInputFields: CargoTemperatureInputField[]) => void;
    setSelectedCargoTempDate: (date: Date | null) => void;
    setIsCommentsVisible: (isVisible: boolean | undefined) => void;
    setHasMissingConfigs: (hasMissingConfigs: boolean) => void;
    setFilteredCargoTemperatureConfigs: (cargoTemperatureConfig: CargoTemperatureConfig[]) => void;
    setCargoTempLogReportLog: (cargoTemperatureLogEntry: CargoTemperatureLogEntry[]) => void;
    setSelectedTab: (selectedTab: tabEnum) => void;
};

export const CargoTempLogContext = React.createContext<CargoTempLogContextType>(undefined);

export const CargoTempLogProvider = ({ children }: ContextProps) => {
    const [cargoTempLogDates, setCargoTempLogDates] = useState<CargoTemperatureLogDate[]>([]);
    const [cargoTemperatureConfigs, setCargoTemperatureConfigs] = useState<CargoTemperatureConfig[] | null>(null);
    const [cargoTemperatureInputFields, setCargoTemperatureInputFields] = useState<CargoTemperatureInputField[]>([]);
    const [selectedCargoTempDate, setSelectedCargoTempDate] = useState<Date | null>(null);
    const [isCommentsVisible, setIsCommentsVisible] = useState<boolean>(false);
    const [hasMissingConfigs, setHasMissingConfigs] = useState<boolean>(false);
    const [filteredCargoTemperatureConfigs, setFilteredCargoTemperatureConfigs] = useState<CargoTemperatureConfig[]>([]);
    const [cargoTempLogReportLog, setCargoTempLogReportLog] = useState<CargoTemperatureLogEntry[]>([]);
    const [selectedTab, setSelectedTab] = useState<tabEnum>(tabEnum.reporting);

    return (
        <CargoTempLogContext.Provider
            value={{
                cargoTempLogDates,
                setCargoTempLogDates,
                cargoTemperatureConfigs,
                setCargoTemperatureConfigs,
                cargoTemperatureInputFields,
                setCargoTemperatureInputFields,
                selectedCargoTempDate,
                setSelectedCargoTempDate,
                hasMissingConfigs,
                setHasMissingConfigs,
                isCommentsVisible,
                setIsCommentsVisible,
                filteredCargoTemperatureConfigs,
                setFilteredCargoTemperatureConfigs,
                cargoTempLogReportLog,
                setCargoTempLogReportLog,
                selectedTab,
                setSelectedTab,
            }}
        >
            {children}
        </CargoTempLogContext.Provider>
    );
};

export const useCargoTempLogStore = () => useContext(CargoTempLogContext);
